export const SPRUCE_HELMET_STEP = 'spruce-helmet' 
export const SPRUCE_HELMET_DESCRIPTION = "Motorycle Helmet"
export const HELMET = "helmets"